import React, { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { standardActions } from '../../../Utils/Grid/StandardActions';
import Table from '../../../Utils/Grid';
import Search from '../../../Utils/Search';
import { useList } from '../../../../hooks/useList';
import { useDelete } from '../../../../hooks/useDelete';
import LoaderContext from '../../../../context/LoaderContext';
import UserContext from '../../../../context/UserContext';
import { ASSISTANT, TYPE_BENEFICIARY_OPTIONS } from '../../../../../utility/constants';
import InputSelect from '../../../Utils/InputSelect';
import { NotificationManager } from 'react-notifications';
import { api } from 'api';
import _ from 'lodash';

const ListBeneficiaries = () => {
    const { loader } = useContext(LoaderContext);
    const { user }= useContext(UserContext)
    const [filterActive, setFilterActive] = useState(null);
    const [isSync, setIsSync] = useState(true);
    const [search, setSearch] = useState(null);
    const { data, getData, page, offline } = useList('beneficiary');
    const { deleteData } = useDelete('beneficiary');

    useEffect(() => {
        api.get('offline/is_sync').then((res) => {
            setIsSync(res.is_sync);
        });
    }, []);

    async function onSync() {
        try {
            setIsSync(true);
            await api.get('offline/events');
            await api.get('offline/sync');
            const res = await api.get('offline/is_sync');
            if (res.is_sync === true) {
                NotificationManager.success(
                    'Sincronizarían de datos exitosa.',
                    'Éxito',
                    4000
                );
            }
            setIsSync(res.is_sync);
        } catch (e) {
            NotificationManager.error(
                'No se pudo realizar la sincronizarían.',
                'Error',
                5000
            );
        }
    }

    return (
        <React.Fragment>
            <div className="pt-5" />
            <div className="d-flex flex-column flex-md-row justify-content-between">
                <h1 className="title-2 cl-dark-blue">Beneficiarios</h1>
                { user.type !== ASSISTANT &&(
                <Link to="/beneficiary/create" className="btn btn-primary">
                    Crear Beneficiario
                </Link>
                )}
            </div>
            <div className="d-flex flex-column-reverse flex-sm-row mt-3">
                <Search
                    onSearch={(value) => {
                        getData(1, {
                            search: value,
                            type: filterActive,
                        }).then();
                        setSearch(value);
                    }}
                    placeholder="Buscar por ID, nombre, apellido"
                    className="flex-2"
                />
                <div className="d-flex flex-1 justify-content-center mt-3 mt-md-0">
                    {!isSync && !offline && (
                        <button
                            type="btn"
                            className="btn-sync"
                            onClick={onSync}
                        >
                            <img
                                width={40}
                                height={40}
                                src="data:image/png;base64,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"
                            ></img>
                            <p className="sync-text m-0 ml-2">
                                Sincronizar Datos
                            </p>
                        </button>
                    )}
                </div>
                <div className="d-flex flex-1 justify-content-sm-end">
                    <InputSelect
                        options={TYPE_BENEFICIARY_OPTIONS}
                        value={filterActive}
                        isClearable={true}
                        className="filter-select mt-3 mt-md-0"
                        placeholder="Filtrar por tipo"
                        onChange={(value) => {
                            getData(1, {
                                type: value,
                                search: search,
                            });
                            setFilterActive(value);
                        }}
                    />
                </div>
            </div>
            <Table
                className="mt-5"
                data={data}
                onPageChange={(page) =>
                    getData(page, { search: search, type: filterActive })
                }
                page={page}
                loading={loader}
            >
                <TableHeaderColumn
                    dataField="id"
                    dataAlign="center"
                    width="10rem"
                    isKey
                    dataFormat={standardActions({
                        view: '/beneficiary',
                        update_beneficiary: '/beneficiary',
                        erase: (id) => deleteData(id, getData),
                        type:user.type
                    })}
                >
                    Herramientas
                </TableHeaderColumn>
                <TableHeaderColumn width="10rem" dataField="identification">
                    ID
                </TableHeaderColumn>
                <TableHeaderColumn width="10rem" dataField="first_name">
                    Nombre
                </TableHeaderColumn>
                <TableHeaderColumn width="10rem" dataField="last_name">
                    Apellido
                </TableHeaderColumn>
                <TableHeaderColumn
                    width="10rem"
                    dataField="school"
                    dataFormat={(value) =>
                        value && value.name ? value.name : ''
                    }
                >
                    Colegio
                </TableHeaderColumn>
                {['', undefined, null].includes(filterActive) && (
                    <TableHeaderColumn
                        width="10rem"
                        dataField="type"
                        dataFormat={(value) => {
                            const type = _.find(TYPE_BENEFICIARY_OPTIONS, {
                                value: value,
                            });
                            if (type) return type.label;
                            else return '-----';
                        }}
                    >
                        Tipo Beneficiario
                    </TableHeaderColumn>
                )}
                <TableHeaderColumn width="10rem" dataField="cellphone">
                    Celular
                </TableHeaderColumn>
            </Table>
        </React.Fragment>
    );
};

export default ListBeneficiaries;
